import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { sortWith } from 'ramda';
import { useDispatch } from 'react-redux';

import TrashCan from '@gef-ui/material-icons/TrashCan';

import { deleteWholeManager } from 'features/views/settings/marketPlaceAgencies/editAgencyModal/actions';
import { sortAlphabeticallyBy } from 'utils/sort';
import { joinString } from 'utils/string';

import SubordinatesList from './SubordinatesList';

export const Manager = ({ manager, agency }) => {
	const dispatch = useDispatch();

	const handleDeleteManager = useCallback(() => {
		dispatch(deleteWholeManager({ agency, manager }));
	}, [dispatch, agency, manager]);

	const { sortedAssigned = [], sortedUnassigned = [] } = useMemo(() => {
		const assigned = manager?.subordinates.filter((subordinate) => subordinate?.assigned);
		const unassigned = manager?.subordinates.filter((subordinate) => !subordinate?.assigned);

		const sortedAssigned = sortWith([sortAlphabeticallyBy('surname'), sortAlphabeticallyBy('firstname')])(assigned);
		const sortedUnassigned = sortWith([sortAlphabeticallyBy('surname'), sortAlphabeticallyBy('firstname')])(
			unassigned,
		);

		return { sortedAssigned, sortedUnassigned };
	}, [manager?.subordinates]);

	return (
		<Stack>
			<Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
				<Typography variant="h4" color="text.primary">
					{joinString(' ', [manager?.surname, manager?.firstname])}
				</Typography>
				<IconButton disableRipple onClick={handleDeleteManager}>
					<TrashCan />
				</IconButton>
			</Stack>
			<SubordinatesList
				assigned={sortedAssigned}
				unassigned={sortedUnassigned}
				manager={manager?.userLogin}
				agency={agency?.areaId}
			/>
		</Stack>
	);
};

Manager.propTypes = {
	agency: PropTypes.object,
	manager: PropTypes.object,
};
export default Manager;
